import { render, staticRenderFns } from "./pic.vue?vue&type=template&id=5f2f4d62&scoped=true"
import script from "./pic.vue?vue&type=script&lang=ts"
export * from "./pic.vue?vue&type=script&lang=ts"
import style0 from "./pic.vue?vue&type=style&index=0&id=5f2f4d62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2f4d62",
  null
  
)

export default component.exports